import { type ReactNode, type ComponentProps } from 'react'
import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'

export const HeaderItem = ({
  isSelected = false,
  children,
  holidayGHP,
  ...restProps
}: {
  isSelected?: boolean
  children: ReactNode
  onClick?: ComponentProps<'span'>['onClick']
  holidayGHP?: boolean
}) => {
  return (
    <HeaderItemText
      as="span"
      strong={isSelected}
      variant="primary"
      size="md"
      $holidayGHP={holidayGHP}
      {...restProps}
    >
      {children}
    </HeaderItemText>
  )
}

const HeaderItemText = styled(Body)<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP && theme.color.content.base.neutral.primary_inverse};
  position: relative;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;

  svg {
    margin-right: 0.25rem;
  }

  &:hover {
    font-weight: 600;
  }
`
